import React from "react";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import {
  NavSidebar,
  GroupLeft,
  GroupRight,
  ProfileForm,
  XCancel,
} from "../components";

const GroupWrapper = ({ children, setCommunity, community, setGroup }) => {
  const { user } = useSelector((state) => state.authStore);

  return (
    <div>
      <Popup
        position="right center"
        modal
        open={!user.isProfileCompleted}
        closeOnDocumentClick={false}
        nested
        contentStyle={{
          borderRadius: "12px",
          backgroundColor: "white",
          width: "fit-content",
          fontSize: "0.8rem",
          maxHeight: "98%",
          overflow: "auto",
        }}
      >
        {(close) => (
          <>
            <XCancel close={close} />
            <ProfileForm close={close} />
          </>
        )}
      </Popup>
      <NavSidebar />
      <div className="pt-[110px] pl-44 pr-20 flex justify-between items-start">
        <GroupLeft
          setCommunity={setCommunity}
          community={community}
          setGroup={setGroup}
        />
        {children}
        <GroupRight />
      </div>
    </div>
  );
};

export default GroupWrapper;
